var map = {
	"./flush.png": 9612,
	"./fourofakind.png": 8798,
	"./fullhouse.png": 2016,
	"./highcard.png": 6605,
	"./pair.png": 5071,
	"./royalflush.png": 2578,
	"./straight.png": 465,
	"./straightflush.png": 933,
	"./threeofakind.png": 6026,
	"./twopair.png": 7411,
	"./unknown.png": 1210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9527;